import moment from 'moment'
import Observable from '@/utils/Observable'
import timeRange from '@/utils/timeRange'
import DefaultMap from '@/utils/DefaultMap'

const createdAt = moment().subtract(10, 'days')

function randomFloat(min, max) {
  return Math.random() * (max - min) + min
}

function randomInteger(min, max) {
  return randomFloat(min, max) | 0
}

function* generateRandomTrend(min, max, d = (max - min) / 100) {
  let value = randomFloat(min, max)
  while (true) {
    yield value
    value = randomFloat(Math.max(min, value - d), Math.min(max, value + d))
  }
}

const verbs = [
  'Activate',
  'Boil',
  'Boost',
  'Brew',
  'Coddle',
  'Collect',
  'Deactivate',
  'Disable',
  'Disengage',
  'Engage',
  'Feed',
  'Inject',
  'Jiggle',
  'Lather',
  'Lubricate',
  'Polarize',
  'Pump',
  'Raise',
  'Soak',
  'Squeeze',
  'Suspend',
  'Take',
  'Turn off',
  'Turn on',
  'Vent',
  'Wash',
]

const nouns = [
  'Atonal Plunger',
  'Coffee',
  'Coil-jawed Echodriver',
  'Cross-jawed Vaporlens',
  'Cryptic Disperser',
  'Cycloshackle Cup',
  'Decontaminant Terastructure',
  'Ether Block',
  'Evasive Maneuvers',
  'Fish',
  'Frequency Bolt',
  'Gammabellows',
  'Hydroweb',
  'Iridium Laser',
  'Kettle',
  'Lift Condenser',
  'Macroadapter',
  'Mail',
  'Morale',
  'Netherbraid',
  'Octopickup',
  'Rimcooker',
  'Shields',
  'Spectrumfilter',
  'Subpusher',
  'Tera-bellied Couplet',
  'Titanium Tensor',
  'Twin-toothed Swatter',
  'Ultraphaser',
  'Vortex Structure',
  'Zinc Whistle',
]

function generateAction() {
  const verb = verbs[randomInteger(0, verbs.length)]
  const noun = nouns[randomInteger(0, nouns.length)]
  return `${verb} ${noun}`
}

export const serverNames = ['demo-server-1', 'demo-server-2']

export const applicationName = 'demo-application'
const commit = 'oteotneoteuohteuht'

const loadavgTrends = [
  generateRandomTrend(0, 3),
  generateRandomTrend(0, 3),
  generateRandomTrend(0, 3),
]
const freeMemTrend = generateRandomTrend(0, 67512242176)
const cpuTrend = generateRandomTrend(0, 10, 0.5)
const memoryTrend = generateRandomTrend(30 * 1024 ** 2, 100 * 1024 ** 2)
const latencyTrend = generateRandomTrend(100, 300)
const rpmTrend = generateRandomTrend(20, 100)

function generateProcess(pmId) {
  return {
    isDemo: true,
    pid: pmId + 1000,
    name: applicationName,
    interpreter: 'node',
    restart_time: 0,
    created_at: createdAt.valueOf(),
    exec_mode: 'fork_mode',
    pm_uptime: createdAt.valueOf(),
    status: 'online',
    pm_id: pmId,
    cpu: cpuTrend.next().value,
    memory: memoryTrend.next().value,
    versioning: null,
    server: serverNames[0],
    axm_actions: [
      {
        action_name: 'Engage hyperjig',
        opts: null,
        arity: 1,
      },
      {
        action_name: 'Oscillate the optical refractor',
        opts: null,
        arity: 1,
      },
      {
        action_name: 'Frog blast the vent core',
        opts: null,
        arity: 1,
      },
      {
        action_name: 'km:cpu:profiling:start',
        action_type: 'internal',
        arity: 0,
        opts: null,
      },
      {
        action_name: 'km:cpu:profiling:stop',
        action_type: 'internal',
        arity: 0,
        opts: null,
      },
    ],
    axm_monitor: {
      'Loop delay': {
        alert: {},
        agg_type: 'avg',
        value: '0.38ms',
      },
      WebSockets: {
        alert: {},
        agg_type: 'avg',
        value: 8000,
      },
      'Realtime Users': {
        alert: {},
        agg_type: 'avg',
        value: 7874,
      },
      QPS: {
        alert: {},
        agg_type: 'avg',
        value: 7864,
      },
      'Page Rendered': {
        alert: {},
        agg_type: 'avg',
        value: 3804,
      },
      HTTP: {
        alert: {},
        agg_type: 'avg',
        value: `${rpmTrend.next().value}req/min`,
      },
      'pmx:http:latency': {
        agg_type: 'avg',
        alert: {},
        value: `${latencyTrend.next().value}ms`,
      },
    },
    axm_options: {
      default_actions: true,
      transactions: true,
      tracing_enabled: true,
      heapdump: true,
      http: false,
      http_latency: 200,
      http_code: 500,
      ignore_routes: [],
      profiling: true,
      errors: true,
      alert_enabled: true,
      custom_probes: true,
      network: false,
      ports: false,
      ignoreFilter: {
        method: ['OPTIONS'],
        url: [],
      },
      excludedHooks: [],
      module_conf: {
        es_url: 'http://localhost:9200/',
        workerInterval: 2,
      },
      module_name: 'pm2-elasticsearch',
      module_version: '1.0.1',
      pmx_version: '2.1.0',
      apm: {
        version: '2.1.0',
        type: 'node',
      },
      es_url: 'http://localhost:9200/',
      workerInterval: 2,
      error: true,
      widget: {
        el: {
          actions: true,
          probes: true,
        },
        block: {
          main_probes: ['Elastic status', 'Nodes', 'Shards', 'Indices', 'Documents', 'Store size'],
          meta: true,
          issues: true,
        },
        theme: ['#39bdb1', '#1B2228', 'white', '#807C7C'],
        logo:
          'https://raw.githubusercontent.com/pm2-hive/pm2-elasticsearch/master/pres/elasticsearch.png',
        type: 'generic',
      },
      pid: {},
      isModule: false,
    },
    axm_dynamic: {},
  }
}

export function generateDemoServerStatuses() {
  return [
    {
      server_name: serverNames[1],
      internal_ip: '42.42.42.43',
      protected: false,
      rev_con: false,
      isDemo: true,
      created_at: createdAt.toISOString(),
      updated_at: moment().toISOString(),
      pm2_agent_version: '0.5.16',
      data: {
        process: [
          generateProcess(0),
          generateProcess(1),
          generateProcess(2),
          generateProcess(3),
          generateProcess(4),
          generateProcess(5),
          generateProcess(6),
        ],
        server: {
          loadavg: [
            loadavgTrends[0].next().value,
            loadavgTrends[1].next().value,
            loadavgTrends[2].next().value,
          ],
          total_mem: 67512242176,
          free_mem: freeMemTrend.next().value,
          cpu: {
            number: 2,
            info: 'Dumb(R) Zeon(R) CPU',
          },
          hostname: serverNames[1],
          uptime: 9178148,
          type: 'Linux',
          platform: 'linux',
          arch: 'x64',
          user: 'ubuntu',
          interaction: true,
          pm2_version: '3.0.3',
          node_version: 'v8.9.4',
          active: true,
          remote_ip: '::ffff:42.42.42.42',
        },
      },
    },
    {
      server_name: serverNames[0],
      internal_ip: '42.42.42.42',
      protected: false,
      rev_con: false,
      isDemo: true,
      created_at: createdAt.toISOString(),
      updated_at: moment().toISOString(),
      pm2_agent_version: '0.5.16',
      data: {
        process: [
          generateProcess(0),
          generateProcess(1),
          generateProcess(2),
          generateProcess(3),
          generateProcess(4),
          generateProcess(5),
          generateProcess(6),
        ],
        server: {
          loadavg: [
            loadavgTrends[0].next().value,
            loadavgTrends[1].next().value,
            loadavgTrends[2].next().value,
          ],
          total_mem: 67512242176,
          free_mem: freeMemTrend.next().value,
          cpu: {
            number: 2,
            info: 'Dumb(R) Zeon(R) CPU',
          },
          hostname: serverNames[0],
          uptime: 9178148,
          type: 'Linux',
          platform: 'linux',
          arch: 'x64',
          user: 'ubuntu',
          interaction: true,
          pm2_version: '3.0.3',
          node_version: 'v8.9.4',
          active: true,
          remote_ip: '::ffff:42.42.42.42',
        },
      },
    },
  ]
}

export function getDemoExceptionsHistogram({ identifier, interval }) {
  const values = new DefaultMap(() => new DefaultMap(() => 0))

  exceptionInfos.forEach(infos => {
    if (identifier && infos.id !== identifier) return []
    infos.timestamps.forEach(timestamp => {
      const ts = timestamp.valueOf()
      const keyValues = values.get(ts - (ts % interval))
      keyValues.set(infos.id, keyValues.get(infos.id) + 1)
    })
  })

  return Array.from(values, ([key, issues]) => ({
    key,
    issues: Array.from(issues, ([key, count]) => ({
      key,
      doc_count: count,
    })),
  })).sort((a, b) => a.key - b.key)
}

const exceptionInfos = [
  {
    id: 'oenstoentustunensouoetsoeut',
    data: {
      params: {},
      action: 'GET',
      component: '/api/octopickup/conf',
      url: '/api/octopickup/conf',
      message: 'Converting circular structure to JSON',
      stack: `TypeError: Converting circular structure to JSON
    at JSON.stringify (<anonymous>)
    at exports.getUserStats (/var/www/octopickup/api/controller.js:73:24)
    at Layer.handle [as handle_request] (/var/www/octopickup/node_modules/express/lib/router/layer.js:95:5)
    `,
      callsite: '/var/www/octopickup/api/controller.js:73:24',
      context: '  ret.userdata = userdata\n\n>>return res.send(JSON.stringify(ret))\n}\n',
    },
    timestamps: timeRange(moment().subtract(2.6, 'days'), moment().subtract(1.3, 'days'), {
      hour: 4.5,
    }),
  },
  {
    id: 'jeqjfeugqnoecoeuoehtoeuoeu',
    data: {
      params: {},
      action: 'POST',
      component: '/api/octopickup/push',
      url: '/api/octopickup/push',
      message: "TypeError: Cannot read property 'conf' of undefined",
      stack: `TypeError: Cannot read property 'conf' of undefined
    at Object.<anonymous> (/var/www/octopickup/api/controller.js:123:22)
    at Layer.handle [as handle_request] (/var/www/octopickup/node_modules/express/lib/router/layer.js:95:5)
    `,
      callsite: '/var/www/octopickup/api/controller.js:123:22',
      context: '  sendTheOctopus();\n\n>>return result.conf;\n}\n',
    },
    timestamps: timeRange(moment().subtract(4.2, 'days'), moment().subtract(2.3, 'days'), {
      hour: 8,
    }),
  },
  {
    id: 'eounsoeohtuqjkfpuhtne',
    data: {
      params: {},
      action: 'PUT',
      component: '/api/octopickup/update',
      url: '/api/octopickup/update',
      message: "TypeError: Cannot read property 'length' of null",
      stack: `TypeError: Cannot read property 'length' of null
    at Object.<anonymous> (/var/www/octopickup/api/model.js:213:28)
    at exports.updateTheOctopus (/var/www/octopickup/api/controller.js:23:24)
    at Layer.handle [as handle_request] (/var/www/octopickup/node_modules/express/lib/router/layer.js:95:5)
    `,
      callsite: '/var/www/octopickup/api/model.js:213:28',
      context: '  release();\n\n>>return result.length > 0;\n}\n',
    },
    timestamps: timeRange(moment().subtract(12.2, 'days'), moment().subtract(8.3, 'days'), {
      hour: 15,
    }),
  },
]

function generateExceptionSource(infos) {
  const start = infos.timestamps[0]
  return {
    process: {
      pm_id: 0,
      name: applicationName,
      rev: commit,
      server: serverNames[0],
    },
    data: Object.assign({}, infos.data, {
      last_logs: [
        `${start
          .clone()
          .subtract(4, 'minutes')
          .toString()}: ${generateAction()}.\n`,
        `${start
          .clone()
          .subtract(3, 'minutes')
          .toString()}: ${generateAction()}.\n`,
        `${start
          .clone()
          .subtract(2, 'minutes')
          .toString()}: ${generateAction()}.\n`,
      ],
    }),
    at: start.toISOString(),
    identifier: infos.id,
    fixed: false,
    created_at: start.toISOString(),
    updated_at: start.toISOString(),
    count: infos.timestamps.length,
    infected_servers: [serverNames[0]],
    timestamps: infos.timestamps.map(t => t.toISOString()),
    commits: infos.timestamps.map(() => commit),
    metadata: {},
  }
}

export function getDemoExceptions() {
  return exceptionInfos.map(infos => {
    const source = generateExceptionSource(infos)
    return {
      identifier: infos.id,
      count: source.timestamps.length,
      last: {
        at: source.at,
        message: source.data.message,
        server: source.process.server,
      },
    }
  })
}

export function getDemoIssueOccurrencesIds(issueId) {
  const infos = exceptionInfos.find(infos => infos.id === issueId)
  if (!infos) return []
  return {
    list: infos.timestamps.map((timestamp, index) => `${issueId}-${index}`),
    total: infos.timestamps.length,
  }
}

export function getDemoIssueOccurrenceInfo(occurrenceId) {
  const [issueId, index] = occurrenceId.split('-')
  const infos = exceptionInfos.find(infos => infos.id === issueId)
  if (!infos) return []
  return {
    id: occurrenceId,
    source: generateExceptionSource(
      Object.assign({}, infos, { timestamps: [infos.timestamps[index]] }),
    ),
  }
}

function generateMetricAggregation(type, name, range) {
  switch (type) {
    case 'histogram': {
      const trend = generateRandomTrend(0, 50)
      return {
        buckets: range.map(time => {
          const count = trend.next().value
          return {
            doc_count: count,
            key: time.valueOf(),
            key_as_string: time.toISOString(),
            stats: {
              avg: count,
              count: count,
              max: count + 10,
              min: Math.max(0, count - 10),
              sum: count,
            },
          }
        }),
      }
    }

    case 'stats':
      return {
        avg: 0.0008237232289950577,
        count: 3642,
        max: 3,
        min: 0,
        sum: 3,
      }

    case 'servers':
  }
}

function generateMetricAggregationTypes(types, name, range) {
  const result = {}
  types.forEach(type => {
    result[type] = generateMetricAggregation(type, name, range)
  })
  return result
}

export function getDemoMetricsAggregations(aggregations) {
  return aggregations.map(({ name, types, start, end, servers }) => {
    start = moment(start)
    end = moment(end)
    const serversIndex = types.indexOf('servers')
    const byServer = serversIndex >= 0
    if (byServer) {
      types = types.filter(type => type !== 'servers')
    }

    const hours = end.diff(start, 'hours')
    const interval =
      hours <= 1
        ? { m: 5 }
        : hours <= 24
        ? { h: 1 }
        : hours <= 24 * 7
        ? { h: 6 }
        : hours <= 24 * 30
        ? { d: 1 }
        : { d: 7 }

    const range = timeRange(start, end, interval)
    if (byServer) {
      if (!servers) servers = serverNames
      return {
        by_server: {
          doc_count_error_upper_bound: 0,
          sum_other_doc_count: 0,
          buckets: servers.map(key => ({
            key,
            doc_count: 2308,
            ...generateMetricAggregationTypes(types, name, range),
          })),
        },
      }
    }
    return generateMetricAggregationTypes(types, name, range)
  })
}

export function getDemoMetrics() {
  return [{ name: 'cpu' }, { name: 'memory' }, { name: 'Loop delay' }]
}

export function getDemoCPUProfileURL() {
  return 'https://gist.githubusercontent.com/BenoitZugmeyer/4f6730760dc33d52121ddcaa2bb2d7fc/raw/demo.cpuprofile'
}

export function getDemoHeapProfileURL() {
  return 'https://gist.githubusercontent.com/ItsJimi/8ad9c37fd845053213ed1e7d6c9effd0/raw/33d37ed69ce21ab65584becbf3b8bb85a8c85914/demo.heaprofile' // TODO: Add a real profile
}

export function getDemoMemorySnapshotURL() {
  return 'https://gist.githubusercontent.com/BenoitZugmeyer/4f6730760dc33d52121ddcaa2bb2d7fc/raw/demo.heapsnapshot'
}

export function generateDemoLogs() {
  return new Observable(observer => {
    let timeout
    function generateNext() {
      observer.next({
        at: Date.now(),
        line: generateAction(),
        isDemo: true,
        process: {
          server: serverNames[0],
          name: applicationName,
          pm_id: 0,
        },
      })
      timeout = setTimeout(generateNext, randomFloat(100, 1500))
    }

    generateNext()

    return () => {
      clearTimeout(timeout)
    }
  })
}

const historyLogsStart = moment().subtract(10, 'days')
const historyLogsEnd = moment()

export function getDemoLogsHistogram() {
  return timeRange(historyLogsStart, historyLogsEnd, { h: 1 }).map(time => ({
    key: time.valueOf(),
    count: Math.random() * 100,
  }))
}

export function getDemoLogsLines({ before, after, size = 40, from = 0 }) {
  const delta = n => ({ m: 1.24 * n })
  let startDate, endDate
  if (before) {
    endDate = moment(before).subtract(delta(from))
    startDate = endDate.clone().subtract(delta(size))
  } else {
    startDate = moment(after).add(delta(from))
    endDate = startDate.clone().add(delta(size))
  }
  const result = timeRange(
    moment.max(startDate, historyLogsStart),
    moment.min(endDate, historyLogsEnd),
    delta(1),
  ).map(date => ({
    at: date.valueOf(),
    line: generateAction(),
    process: {
      server: serverNames[0],
      pm_id: randomInteger(0, 6),
    },
  }))
  if (before) result.reverse()
  return result
}
